import React, {useState} from 'react'
import { useLazyQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { Button } from '@center/ui-kit'

import { OPERATION_EXPORT_STANDARD, OPERATION_EXPORT_H3 } from '../operations-gql/queries'
import { useQueryVariables } from '../store'
import Modal from 'components/Modal'
import { trackEvent } from 'analytics'

const Export = () => {
  const queryVariables = useQueryVariables()
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const [launchExport, { error }] = useLazyQuery(
    (/^\/codes\/standard/).test(location.pathname) ? OPERATION_EXPORT_STANDARD : OPERATION_EXPORT_H3
  )
  const { t } = useTranslation()
  const navigate = useNavigate()
  
  const handleExport = async (format) => {
    setLoading(true)
    const {
      data: { base64 },
    } = await launchExport({
      variables: queryVariables,
    })
    const blob = await (await fetch(base64)).blob()
    const fileUrl = URL.createObjectURL(blob)
    window.open(fileUrl, '_blank')
    trackEvent('export_code', {
      code_type: location.pathname.includes('standard') ? 'standard' : 'h3',
      format,
    })
    setLoading(false)
  }
  
  return (
    <Modal
      icon={<i className="fa-solid fa-arrow-up-from-line" />}
      title={t('coupons.export.title')}
      onClose={() => navigate('..')}
    >
      <Box display="flex" alignSelf="center" mt={3} gap={8}>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Box>{t('export.error')}</Box>
        ) : (
          <>
            <Button
              startIcon={<i className="fa-light fa-file-pdf" />}
              size="large"
              onClick={() => handleExport('pdf')}
              disabled={loading}
              sx={{ fontFamily: 'Poppins' }}
            >
              {t('export.pdf_soon')}
            </Button>
            <Button
              startIcon={<i className="fa-light fa-file-csv" />}
              size="large"
              onClick={() => handleExport('csv')}
              disabled={loading}
              sx={{ fontFamily: 'Poppins' }}
            >
              {t('export.csv')}
            </Button>
          </>
        )}
      </Box>
    </Modal>
  )
}

export default Export
